import { Flex, FlexProps } from 'antd/lib'
import { BlockComponentFactory } from 'shared/express-interface/blocks-core/BlockFactory'

type FlexBlockProps = FlexProps

export const FlexBlockComponent = BlockComponentFactory.createBlockComponent<FlexBlockProps>(
    props => {
        const { children, ...rest } = props
        return <Flex {...rest}>{children}</Flex>
    }
)
